import IPostgresInterval from "app/models/postgresInterval"
import moment, { Moment } from "moment"
import { formatDateTime, toHour, toHourMoment } from "utils"

export function formatTimeToShiftFormatWithMidnight(dateTime: Moment | string, midnight?: boolean) {
  return toHourMoment(dateTime).add(midnight ? 1 : 0, "days")
}

export function formatTimeToShiftFormat(dateTime: Moment | string) {
  const time = formatDateTime(dateTime)
  return moment
    .utc({ year: 2000 })
    .startOf("year")
    .set({ hour: time.get("hour"), minute: time.get("minute") })
    .toISOString()
}

export function isMidnight(time: string | Moment) {
  return toHour(toHourMoment(time)) === "00:00"
}

export function formatMidnightToNextDay(time: string | Moment) {
  if (isMidnight(time)) {
    return toHourMoment(time).add("days", 1)
  }
  return toHourMoment(time)
}

export function formatTimeToHoursAndMinutesFormat(time: string) {
  return moment(time, "HH:mm:ss").format("HH:mm")
}

export function formatPostgresIntervalToDecimalHours({ days, hours, minutes }: IPostgresInterval): number {
  const dayHours = days ? days * 24 : 0
  const newHours = hours || 0
  const newMinutes = minutes ? minutes / 60 : 0
  return dayHours + newHours + newMinutes
}
